import { Box } from '@mui/system';
import React from 'react';
import { IProps } from 'types/common';

interface ITabPanelProps extends IProps {
	id: string | number;
	value: string | number;
	labelId: string;
	controllerId: string;
}

type ExtraBoxProps = Omit<
	React.ComponentProps<typeof Box>,
	keyof ITabPanelProps
>;

const TabPanel: React.FC<ITabPanelProps & ExtraBoxProps> = ({
	id,
	value,
	controllerId,
	labelId,
	children,
	...props
}) => {
	const hidden = value !== id;
	return (
		<Box
			{...props}
			role="tabpanel"
			display={hidden ? undefined : 'flex'}
			flexGrow={1}
			hidden={hidden}
			id={`${labelId}-${id}`}
			aria-labelledby={`${controllerId}-${id}`}
		>
			{value === id && children}
		</Box>
	);
};

export default TabPanel;
